import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TranslocoModule } from '@ngneat/transloco';
import { TelusDropdownComponent } from './dropdown/dropdown';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslocoModule,
    TranslocoLocaleModule.forRoot(),
  ],
  declarations: [TelusDropdownComponent],
  exports: [TelusDropdownComponent],
})
export class TelusCommonModule {}
